import { DocumentStatus } from "types";
import { getDocumentStatusColor } from "utils";

interface DocumentStatusBadgeProps {
  status: DocumentStatus;
}

const DocumentStatusBadge = ({ status }: DocumentStatusBadgeProps) => {
  if (!status) return null;

  const statusLabel = status.replace(/_/g, " ").toLowerCase();
  const capitalizedLabel = statusLabel.charAt(0).toUpperCase() + statusLabel.slice(1);

  return (
    <span
      className={`inline-flex items-center rounded-md px-2.5 py-1 text-xs font-medium ${getDocumentStatusColor(status)}`}
    >
      {capitalizedLabel}
    </span>
  );
};

export default DocumentStatusBadge;
